import Home from "./components/Home";

function App() {
  return (
    <div className="app-shell">
      <Home />
    </div>
  );
}

export default App;